import * as React from 'react';
import classnames from 'classnames';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { UnitPrice, BestPrice, toast, Tag } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { Discount } from '@grandvisionhq/fun-products';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import ProductReimbursableLogo from '../../ProductReimbursableLogo/ProductReimbursableLogo.js';
import { isContactLenses } from '../types.js';
import Details from './Details/Details.js';
import Images from './Images/Images.js';
import Prices from './Prices/Prices.js';
import VariantSwitcher from './VariantSwitcher/VariantSwitcher.js';
import { useProductBlockSlots } from '../slots/context.js';

const ProductBlock = /*#__PURE__*/ React.forwardRef(({ brand , discounted , name , url , productType , activeSku , images , price , pricePerUnit , pricePerLiterFixedDecimals , discountedPrice , variants , offering , promotionLabel , className , onVariantChange , onClick , isInsuranceReimbursable , reimbursableLogos , isReimbursableFiltered , tag , bestPrice , enableAddToCartCta =false ,  }, ref)=>{
    const { getLabel , getFormattedLabel , currency  } = useIntl();
    const { isPricePerLiterEnabled , isBestPriceEnabled  } = useFeatureToggles();
    const { Slots  } = useProductBlockSlots();
    const itemDraft = {
        sku: activeSku,
        quantity: 1,
        type: 'regular'
    };
    if (!activeSku || !isDefined(price) || !url) {
        console.warn(`Cannot render ProductBlock component without a valid price: ${price} and url: ${url} and active sku: ${activeSku}.`);
        return null;
    }
    /*
      Precedence of the labels to show in the product tile header:
      1. If the product has both and a product tag and isReimbursable => only the reimbursable logo is shown
      2. If the product has product tag only => product tag is shown
    */ const getHeaderTag = ()=>{
        if (isInsuranceReimbursable) return /*#__PURE__*/ React.createElement(ProductReimbursableLogo, {
            logos: reimbursableLogos,
            variant: isReimbursableFiltered ? 'alternative' : 'default'
        });
        if (tag) return /*#__PURE__*/ React.createElement(Tag, {
            iconKey: tag.key,
            label: tag.value
        });
    };
    const productBody = /*#__PURE__*/ React.createElement("a", {
        ref: ref,
        href: url,
        onClick: onClick,
        "aria-label": `${brand} ${name}`,
        "data-t": "product-block",
        className: classnames({
            'product-block': !enableAddToCartCta,
            'product-block__link': enableAddToCartCta,
            'product-block--contact-lenses': isContactLenses(productType)
        }, className)
    }, /*#__PURE__*/ React.createElement("aside", {
        className: "product-block__header"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-block__header-left"
    }, getHeaderTag()), /*#__PURE__*/ React.createElement("div", {
        className: "product-block__header-right"
    }, Slots.WishlistButton ? /*#__PURE__*/ React.createElement(Slots.WishlistButton, {
        sku: activeSku
    }) : null)), /*#__PURE__*/ React.createElement("div", {
        className: "product-block__main"
    }, /*#__PURE__*/ React.createElement(Images, {
        front: images.front,
        angle: images.angle
    }), /*#__PURE__*/ React.createElement(Details, {
        brand: brand,
        name: name
    }), /*#__PURE__*/ React.createElement(Prices, {
        price: price,
        discountedPrice: discountedPrice
    }), discounted && /*#__PURE__*/ React.createElement(Discount, {
        className: "product-block__discount",
        label: promotionLabel,
        discount: discounted
    }), isPricePerLiterEnabled && (pricePerUnit === null || pricePerUnit === void 0 ? void 0 : pricePerUnit.amount) && (pricePerUnit === null || pricePerUnit === void 0 ? void 0 : pricePerUnit.currencyCode) && /*#__PURE__*/ React.createElement(UnitPrice, {
        className: "product-block__unit-price",
        amount: pricePerUnit === null || pricePerUnit === void 0 ? void 0 : pricePerUnit.amount,
        fixedDecimals: pricePerLiterFixedDecimals,
        currencyCode: pricePerUnit === null || pricePerUnit === void 0 ? void 0 : pricePerUnit.currencyCode
    }), /*#__PURE__*/ React.createElement(BestPrice, {
        isCentAmount: true,
        isFeatureEnabled: isBestPriceEnabled,
        amount: bestPrice,
        currencyCode: currency,
        discountedPrice: discountedPrice,
        originalPrice: price,
        className: 'product-block__best-price'
    })), /*#__PURE__*/ React.createElement("footer", {
        className: "product-block__footer"
    }, !!(variants === null || variants === void 0 ? void 0 : variants.length) && /*#__PURE__*/ React.createElement(VariantSwitcher, {
        variants: variants,
        activeSku: activeSku,
        onVariantChange: onVariantChange,
        className: "product-block__variant-switcher"
    }), (offering === null || offering === void 0 ? void 0 : offering.includesLenses) && /*#__PURE__*/ React.createElement(Text, {
        className: "product-block__bottom-link"
    }, getFormattedLabel('products.glasses.offering.includesLenses', {
        parseLink: true,
        hideLabelKey: true
    }))));
    if (!enableAddToCartCta) {
        return productBody;
    } else {
        return /*#__PURE__*/ React.createElement("div", {
            className: "product-block product-block__with-cta"
        }, productBody, enableAddToCartCta && /*#__PURE__*/ React.createElement(AddToCart, {
            onSuccess: ()=>{
                toast.success('cart.success.notification');
            },
            variant: "ghost",
            caption: getLabel('cart.actions.addToCart'),
            lineItemDrafts: [
                itemDraft
            ]
        }));
    }
});
var ProductBlock$1 = ProductBlock;

export { ProductBlock, ProductBlock$1 as default };
//# sourceMappingURL=ProductBlock.js.map
